module.exports = __webpack_public_path__ + "images/code.cd2203de3b3c459e047f77e3c142de74.jpg";